import { type SearchParamDefinition } from '@/global/types/SearchParamDefinition'

export const ENTRY_ID_PARAM = 'entry_id'
export const SLIDE_TAB_PARAM = 'slide_tab'
export const PAGE_TAB_PARAM = 'tab'
export const DEFAULT_SORT_ORDER = 'desc'

export const SORT_ORDER_OPTIONS = ['asc', 'desc'] as const

export const SORT_ORDER_PARAM = 'sortOrder'
export const SORT_BY_PARAM = 'sort'

export const DEFAULT_SORT_ORDER_PARAM_DEF = {
  name: SORT_ORDER_PARAM,
  type: 'single',
  values: SORT_ORDER_OPTIONS,
  defaultValue: DEFAULT_SORT_ORDER,
} as const satisfies SearchParamDefinition

export const SORT_ORDER_KEY_TO_LABEL = {
  asc: 'ascending',
  desc: 'descending',
}

export const SORT_DROPDOWN_SEPARATOR = Symbol()
